export const POC_LIGHTNING_OUT_LOGIN_CALLBACK_PATH = "/salesforce-poc/lightning-out-auth"
export const salesforceRedirectUrl = () => {
	return new URL(POC_LIGHTNING_OUT_LOGIN_CALLBACK_PATH, window.location.origin).toString()
}
